import React, { Fragment, lazy } from 'react';
import { Section } from './ui/Section';
export function TomosDetail() {
  const tomos = [{
    icon: '📘',
    title: 'TOMO 1 — AUTOPSIA DE TU BAÑO',
    subtitle: 'Diagnóstico completo de tu piel y auditoría brutal de tus productos',
    desc: 'El primer paso no es comprar nada nuevo. Es entender exactamente qué tienes, qué te está dañando y qué merece quedarse.',
    features: ['Diagnóstico en 6 parámetros (sebo, barrera, hidratación, sensibilidad, pigmentación, textura)', 'Sistema de clasificación Verde / Amarillo / Rojo para cada producto de tu baño', 'Los 7 ingredientes criminales que destruyen tu piel sin que lo sepas', 'Test de tipo de piel real (no el de las revistas)', 'Inventario completo listo para rellenar']
  }, {
    icon: '📗',
    title: 'TOMO 2 — LA MATRIZ DE ACTIVOS',
    subtitle: 'La ciencia de los ingredientes: qué hace cada uno, cómo combinarlos y en qué orden usarlos',
    desc: 'Retinol, vitamina C, niacinamida, ácido hialurónico, AHA, BHA... ¿Sabes realmente cómo funcionan y por qué algunos se cancelan entre sí?',
    features: ['Guía completa de los 15 activos más usados en skincare', 'Tabla de compatibilidades e incompatibilidades', 'Orden de aplicación correcto según pH y textura', 'Qué activos usar según tu tipo de piel', 'Errores de combinación que inflaman la piel sin saberlo']
  }, {
    icon: '📙',
    title: 'TOMO 3 — EL PROTOCOLO RESET',
    subtitle: '7 días para reparar tu barrera cutánea y devolver el equilibrio a tu piel',
    desc: 'Antes de añadir nada nuevo, tu piel necesita recuperarse. Este protocolo elimina la sobre-estimulación, calma la inflamación y reconstruye la barrera desde cero.',
    features: ['Protocolo día a día con instrucciones exactas', 'Rutina mañana y noche simplificada al máximo', 'Qué puedes y qué NO puedes usar durante el reset', 'Señales de que tu barrera está reparándose', 'Cómo saber cuándo estás lista para el siguiente paso']
  }, {
    icon: '📕',
    title: 'TOMO 4 — RECONSTRUCCIÓN INTELIGENTE',
    subtitle: 'Reintroducción progresiva de activos y construcción de tu rutina definitiva',
    desc: 'Una vez reparada la barrera, es hora de construir una rutina con sentido. No más rutinas de 12 pasos. Solo lo que tu piel necesita, en el orden correcto.',
    features: ['Protocolo de reintroducción de activos paso a paso', 'Cómo testear un nuevo producto sin arriesgar tu piel', 'Rutinas avanzadas para necesidades específicas', 'Construcción de tu rutina mínima de máximo resultado', 'Cómo leer una etiqueta INCI como una experta']
  }, {
    icon: '📔',
    title: 'TOMO 5 — TU PIEL PARA SIEMPRE',
    subtitle: 'Sistema de mantenimiento permanente: por estaciones, por edad y por etapas',
    desc: '',
    features: ['Cómo adaptar tu rutina en cada estación del año', 'Cambios de piel por edad: 25, 30, 35, 40, 45+', 'Piel y ciclo hormonal: cómo anticipar los cambios', 'Sistema de revisión trimestral de tu rutina', 'Tu protocolo de mantenimiento de por vida']
  }];
  return <Section variant="alt" data-id="element-229">
      <div className="text-center mb-12" data-id="element-230">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-title mb-4" data-id="element-231">
          📚 LOS 5 TOMOS COMPLETOS
        </h2>
      </div>

      <div className="space-y-8 max-w-3xl mx-auto" data-id="element-232">
        {tomos.map((tomo, i) => <Fragment key={i} data-id="element-233">
            <div className="bg-white border border-neutral-200 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-234">
              <div className="flex flex-col md:flex-row gap-6" data-id="element-235">
                <div className="text-5xl shrink-0" data-id="element-236">{tomo.icon}</div>
                <div data-id="element-237">
                  <h3 className="font-heading text-xl font-bold text-brand-title mb-2" data-id="element-238">
                    {tomo.title}
                  </h3>
                  <p className="font-body text-brand-subtitle font-medium mb-3" data-id="element-239">
                    {tomo.subtitle}
                  </p>
                  {tomo.desc && <p className="font-body text-brand-text mb-6" data-id="element-240">
                      {tomo.desc}
                    </p>}

                  <ul className="space-y-3 mt-4" data-id="element-241">
                    {tomo.features.map((feat, j) => <li key={j} className="flex items-start gap-3" data-id="element-242">
                        <span className="text-green-500 shrink-0 mt-0.5" data-id="element-243">
                          ✅
                        </span>
                        <span className="font-body text-brand-text text-sm" data-id="element-244">
                          {feat}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>

            {/* Preview image after Tomo 2 */}
            {i === 1 && <figure className="my-8" data-id="element-245">
                <img src="https://cdn.magicpatterns.com/uploads/dVVhRixkYXaZMffAh38qsa/Diseno_sin_titulo.webp" alt="Vista previa del contenido: Estructura, orden y listas de compra del Tomo 2" width={1000} height={750} loading="lazy" decoding="async" className="w-full rounded-lg shadow-md" style={{
            maxWidth: '100%',
            borderRadius: '8px'
          }} data-id="element-246" />
                <figcaption className="font-body text-sm text-brand-subtitle text-center mt-4 italic px-4" data-id="element-247">
                  Orden, tiempos de espera y listas de compra: Sabrás
                  exactamente qué paso va antes que otro y cuánto tiempo esperar
                  para maximizar cada activo.
                </figcaption>
              </figure>}
          </Fragment>)}
      </div>
    </Section>;
}